import React from 'react';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AuthService } from '../../services/auth';
import { DeereFetch, DeereCachedFetch } from '../../shared/fetch';
import styles from './index.css';

export class AssignTo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            opened: false,
            users: []
        };

        this.anchor = React.createRef();

        this.toggle = this.toggle.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    async componentDidMount() {
        this.setState({
            loading: true
        });
        try {
            const users = await DeereCachedFetch('/api/users', {
                query: {
                    countries: this.props.quote.countryCode,
                    roles: ['ADMIN', 'ASSIGN'],
                    sort: 'firstName,asc'
                }
            });

            this.setState({
                users: [{
                    label: 'Unassign',
                    value: null
                }].concat(users.map((user) => ({
                    label: AuthService.name(user),
                    value: user.id
                })))
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    async assignToCurrentUser() {
        this.close();

        this.setState({
            loading: true
        });
        try {
            const currentUser = await AuthService.user;
            await this.assign(currentUser.id);
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    async assign(id) {
        this.close();

        this.setState({
            loading: true
        });
        try {
            // Assign here
            const quote = await DeereFetch(`/api/quotes/${this.props.quote.id}/assign`, {
                method: 'POST',
                query: {
                    userID: id
                }
            });

            if (this.props.onAssign) this.props.onAssign(quote);
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    toggle() {
        this.setState((prevState) => ({
            opened: !prevState.opened
        }));
    }

    open() {
        this.setState({
            opened: true
        });
    }

    close() {
        this.setState({
            opened: false
        });
    }

    render() {
        return (
            <div className={`${styles.root} ${this.props.className}`} style={this.props.style}>
                <ButtonGroup aria-label="split button" color="primary" ref={this.anchor} variant="contained">
                    <Button
                        className={styles.self}
                        disabled={this.props.disabled || this.state.loading}
                        onClick={(event) => {
                            event.stopPropagation();
                            this.assignToCurrentUser();
                        }}>
                        Assign to Me
                    </Button>
                    <Button
                        aria-haspopup="true"
                        aria-owns={this.state.opened ? 'menu-list-grow' : undefined}
                        color="primary"
                        disabled={this.props.disabled || this.state.loading}
                        onClick={(event) => {
                            event.stopPropagation();
                            this.toggle();
                        }}
                        size="small">
                        <ArrowDropDownIcon />
                    </Button>
                </ButtonGroup>
                {this.state.loading && <CircularProgress disableShrink size={24} style={{ position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12 }} />}
                <Popper anchorEl={this.anchor.current} disablePortal open={this.state.opened} style={{ zIndex: 9999 }} transition>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                            }}
                        >
                            <Paper id="menu-list-grow">
                                <ClickAwayListener onClickAway={this.close}>
                                    <MenuList>
                                        {this.state.users.map(({ label, value }) => (
                                            <MenuItem
                                                disabled={this.props.quote.assignedTo === value}
                                                key={value}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    this.assign(value);
                                                }}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        )
    }
}
